// The sheet exported by the mock-up page (spec PB-3, « Planche »): up to 6 views, three per row, under the customer's
// name, with the printed mention « Visuel indicatif, ne vaut pas BAT » and a diagonal watermark. Plain SVG drawn on a
// canvas to make the PNG: system fonts only, colours written out.
const INK = "#1C1B18"
const MUTED = "#5E5A50"
const NOTE_BG = "#FFF2CC"
const NOTE_INK = "#5C4300"
const TILE_BG = "#F6F0E1"
const [TILE_WIDTH, TILE_HEIGHT, CAPTION, GAP, PADDING, HEAD, FOOT] = [400, 470, 54, 24, 40, 120, 86]
// Room kept for the brand on the right of the title, and the mean width of a character per pixel of font size
const BRAND_ROOM = 150
const CHAR_WIDTH = 0.58

export const escapeXml = (value) => String(value ?? "").replace(/[&<>"']/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[char])

// Cut to the width it may take, as the canvas cannot wrap a text
const fit = (value, width, size) => {
  const max = Math.floor(width / (size * CHAR_WIDTH))
  const content = String(value ?? "")
  return content.length > max ? `${content.slice(0, max - 1).trimEnd()}…` : content
}

const text = (x, y, size, content, attributes = "") => `<text x="${x}" y="${y}" font-size="${size}" ${attributes}>${escapeXml(content)}</text>`

// tiles: [{ svg, title, caption }], svg being the view's own <svg> element; the texts are already translated
export function sheetSvg({ tiles, title, subtitle, brand, mention, detail, watermark }) {
  const columns = Math.min(tiles.length, 3)
  const rows = Math.ceil(tiles.length / columns)
  // Two columns wide at least, so that a single view leaves room for the header; the views are centred
  const span = (count) => count * TILE_WIDTH + (count - 1) * GAP
  const width = PADDING * 2 + span(Math.max(columns, 2))
  const left = (width - span(columns)) / 2
  const height = HEAD + rows * (TILE_HEIGHT + CAPTION) + (rows - 1) * GAP + FOOT + PADDING
  const drawn = tiles.map((tile, index) => {
    const x = left + (index % columns) * (TILE_WIDTH + GAP)
    const y = HEAD + Math.floor(index / columns) * (TILE_HEIGHT + CAPTION + GAP)
    return `<rect x="${x}" y="${y}" width="${TILE_WIDTH}" height="${TILE_HEIGHT + CAPTION}" rx="18" fill="${TILE_BG}"/>
      ${tile.svg.replace("<svg ", `<svg x="${x}" y="${y}" width="${TILE_WIDTH}" height="${TILE_HEIGHT}" `)}
      ${text(x + 18, y + TILE_HEIGHT + 22, 17, fit(tile.title, TILE_WIDTH - 36, 17), `font-weight="700" fill="${INK}"`)}
      ${text(x + 18, y + TILE_HEIGHT + 42, 14, fit(tile.caption, TILE_WIDTH - 36, 14), `fill="${MUTED}"`)}`
  }).join("")
  const watermarks = []
  for (let row = 0, y = HEAD; y < height; row++, y += 170) {
    for (let x = -260 + (row % 2) * 300; x < width; x += 640) {
      watermarks.push(text(x, y, 26, watermark, `transform="rotate(-28 ${x} ${y})" font-weight="800" fill="${INK}" fill-opacity=".06"`))
    }
  }
  const note = height - PADDING - FOOT
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" font-family="Arial, Helvetica, sans-serif">
    <rect width="${width}" height="${height}" fill="#FFFFFF"/>
    ${text(PADDING, 62, 26, fit(title, width - PADDING * 2 - BRAND_ROOM, 26), `font-weight="800" fill="${INK}"`)}
    ${text(PADDING, 92, 16, fit(subtitle, width - PADDING * 2, 16), `fill="${MUTED}"`)}
    ${text(width - PADDING, 62, 24, brand, `font-weight="800" fill="${INK}" text-anchor="end"`)}
    ${drawn}
    <g>${watermarks.join("")}</g>
    <rect x="${PADDING}" y="${note + 20}" width="${width - PADDING * 2}" height="${FOOT - 20}" rx="14" fill="${NOTE_BG}"/>
    ${text(PADDING + 22, note + 52, 17, mention, `font-weight="800" fill="${NOTE_INK}"`)}
    ${text(PADDING + 22, note + 74, 14, detail, `fill="${NOTE_INK}"`)}
  </svg>`
}
